/* =====================================================================
   Collection Quick Add
   - Inline variant picker for product cards (color swatches + option pills)
   - Resolves selection → variant, updates ATC / price / image / sold-out
   - AJAX add-to-cart loading / success / error feedback + toast
   ===================================================================== */

(function () {
  'use strict';

  if (window.__collectionQuickAddInit) return;
  window.__collectionQuickAddInit = true;

  var ATC_SELECTOR =
    '[data-main-collection-grid-add-to-cart], [data-featured-products-add-to-cart]';
  var SOLDOUT_CLASSES = ['btn--soldout', 'is-soldout'];

  // ------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getVariants(optionsWrap) {
    var tag = optionsWrap.querySelector('.collection-variants-data');
    if (!tag) return [];
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelection(optionsWrap) {
    var selection = [
      optionsWrap.dataset.defaultOption1 || null,
      optionsWrap.dataset.defaultOption2 || null,
      optionsWrap.dataset.defaultOption3 || null,
    ];
    optionsWrap.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = parseInt(group.dataset.optionPosition, 10);
      if (!pos) return;
      var active = group.querySelector('button.is-active[data-option-value]');
      if (active) {
        selection[pos - 1] = active.dataset.optionValue;
        return;
      }
      var sel = group.querySelector('select.collection-option-select');
      if (sel) selection[pos - 1] = sel.value;
    });
    return selection;
  }

  function findVariant(variants, selection) {
    return variants.find(function (v) {
      return (
        (selection[0] == null || v.option1 === selection[0]) &&
        (selection[1] == null || v.option2 === selection[1]) &&
        (selection[2] == null || v.option3 === selection[2])
      );
    });
  }

  function findVariantById(variants, id) {
    if (!id) return null;
    return (
      variants.find(function (v) {
        return String(v.id) === String(id);
      }) || null
    );
  }

  // Color-only cards (search): use preferred variant id on the swatch.
  // Full option cards (collection): always resolve from current size+color selection.
  function resolveVariant(optionsWrap, btn) {
    var variants = getVariants(optionsWrap);
    var colorOnly = optionsWrap.dataset.colorOnly === 'true';
    var variant = null;

    if (colorOnly && btn && btn.dataset.preferredVariantId) {
      variant = findVariantById(variants, btn.dataset.preferredVariantId);
    }
    if (!variant) variant = findVariant(variants, getSelection(optionsWrap));

    if (
      !variant &&
      colorOnly &&
      btn &&
      btn.dataset.variantPrice !== undefined &&
      btn.dataset.variantPrice !== ''
    ) {
      return {
        id: btn.dataset.preferredVariantId || '',
        available: true,
        price: parseInt(btn.dataset.variantPrice, 10) || 0,
        compare_at_price: parseInt(btn.dataset.variantCompare || '0', 10) || 0,
        image: btn.dataset.variantImage || '',
      };
    }

    return variant;
  }

  function markUnavailable(optionsWrap, variants, selection) {
    optionsWrap.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = parseInt(group.dataset.optionPosition, 10);
      if (!pos) return;

      group.querySelectorAll('button[data-option-value]').forEach(function (btn) {
        var testSel = selection.slice();
        testSel[pos - 1] = btn.dataset.optionValue;
        var match = findVariant(variants, testSel);
        if (!match || !match.available) {
          btn.classList.add('is-unavailable');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.classList.remove('is-unavailable');
          btn.removeAttribute('aria-disabled');
        }
      });

      var sel = group.querySelector('select.collection-option-select');
      if (sel) {
        Array.from(sel.options).forEach(function (opt) {
          if (!opt.dataset.qaOrig) opt.dataset.qaOrig = opt.textContent;
          var testSel = selection.slice();
          testSel[pos - 1] = opt.value;
          var match = findVariant(variants, testSel);
          if (!match) {
            opt.disabled = true;
            opt.textContent = opt.dataset.qaOrig + ' \u2014 unavailable';
          } else if (!match.available) {
            opt.disabled = false;
            opt.textContent = opt.dataset.qaOrig + ' \u2014 sold out';
          } else {
            opt.disabled = false;
            opt.textContent = opt.dataset.qaOrig;
          }
        });
      }
    });
  }

  function getStrings() {
    var s = window.variantStrings || {};
    return {
      addToCart: s.addToCart || 'Add to cart',
      soldOut: s.soldOut || 'Sold out',
      unavailable: s.unavailable || 'Unavailable',
    };
  }

  function findLabelTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue && node.nodeValue.trim()) {
        return node;
      }
    }
    return null;
  }

  function setButtonText(btn, text) {
    var node = findLabelTextNode(btn);
    if (node) {
      node.nodeValue = ' ' + text + ' ';
    } else {
      btn.insertBefore(document.createTextNode(' ' + text + ' '), btn.firstChild);
    }
  }

  function snapshotDefaultText(btn) {
    if (btn.dataset.qaDefaultText) return;
    var node = findLabelTextNode(btn);
    btn.dataset.qaDefaultText = node ? node.nodeValue.trim() : getStrings().addToCart;
  }

  function applyAtcState(btn, variant) {
    snapshotDefaultText(btn);
    var strings = getStrings();
    if (!variant) {
      btn.dataset.variantId = '';
      SOLDOUT_CLASSES.forEach(function (c) {
        btn.classList.add(c);
      });
      btn.setAttribute('aria-disabled', 'true');
      setButtonText(btn, strings.unavailable);
    } else if (!variant.available) {
      btn.dataset.variantId = variant.id;
      SOLDOUT_CLASSES.forEach(function (c) {
        btn.classList.add(c);
      });
      btn.setAttribute('aria-disabled', 'true');
      setButtonText(btn, strings.soldOut);
    } else {
      btn.dataset.variantId = variant.id;
      SOLDOUT_CLASSES.forEach(function (c) {
        btn.classList.remove(c);
      });
      btn.removeAttribute('aria-disabled');
      setButtonText(btn, btn.dataset.qaDefaultText || strings.addToCart);
    }
  }

  function getVariantImage(optionsWrap, variant) {
    if (variant && variant.image) return variant.image;
    var activeSwatch = optionsWrap.querySelector(
      '.collection-color-swatches .collection-swatch-dot.is-active[data-variant-image]'
    );
    return activeSwatch && activeSwatch.dataset.variantImage
      ? activeSwatch.dataset.variantImage
      : '';
  }

  function syncPrice(card, price, compare) {
    var priceEl = card.querySelector('.product-price');
    if (priceEl) priceEl.textContent = formatMoney(price);

    var compareEl = card.querySelector('.product-compare-price');
    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    var saveEl = card.querySelector('.product-save-badge');
    if (saveEl) {
      if (compare > price) {
        var percent = Math.round(((compare - price) * 100) / compare);
        var tpl =
          (window.variantStrings && window.variantStrings.savePercent) ||
          'Save __PERCENT__%';
        saveEl.textContent = tpl.replace('__PERCENT__', String(percent));
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }
  }

  function syncImage(card, optionsWrap, variant) {
    var nextImage = getVariantImage(optionsWrap, variant);
    var primaryImage = card.querySelector('.primary-image');
    if (!primaryImage || !nextImage) return;
    if (primaryImage.currentSrc === nextImage || primaryImage.src === nextImage) return;
    primaryImage.src = nextImage;
    primaryImage.removeAttribute('srcset');
  }

  function syncQuantity(card, variant) {
    var wrap = card.querySelector('[data-collection-card-qty]');
    if (!wrap || !variant) return;
    var input = wrap.querySelector('.collection-card-qty__input');
    if (!input) return;

    var rule = variant.quantity_rule || {};
    var min = parseInt(rule.min, 10);
    if (!min || min < 1) min = 1;
    var step = parseInt(rule.increment, 10);
    if (!step || step < 1) step = 1;
    var max = rule.max == null ? null : parseInt(rule.max, 10);
    if (
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy === 'deny' &&
      typeof variant.inventory_quantity === 'number' &&
      variant.inventory_quantity > 0
    ) {
      if (max == null || variant.inventory_quantity < max) {
        max = variant.inventory_quantity;
      }
    }

    wrap.dataset.min = String(min);
    wrap.dataset.step = String(step);
    input.min = String(min);
    input.step = String(step);
    if (max != null && !Number.isNaN(max)) {
      wrap.dataset.max = String(max);
      input.max = String(max);
    } else {
      delete wrap.dataset.max;
      input.removeAttribute('max');
    }

    var qty = parseInt(input.value, 10);
    if (Number.isNaN(qty) || qty < min) qty = min;
    if (max != null && !Number.isNaN(max) && qty > max) qty = max;
    input.value = String(qty);

    var minus = wrap.querySelector('button[name="minus"]');
    var plus = wrap.querySelector('button[name="plus"]');
    if (minus) minus.disabled = qty <= min;
    if (plus) plus.disabled = max != null && !Number.isNaN(max) && qty >= max;
  }

  function updateCard(optionsWrap, variant) {
    var card = optionsWrap.closest('.product-item') || optionsWrap.closest('.product');
    if (!card) return;

    card.querySelectorAll(ATC_SELECTOR).forEach(function (btn) {
      applyAtcState(btn, variant);
    });

    if (!variant) return;
    syncPrice(card, variant.price, variant.compare_at_price || 0);
    syncImage(card, optionsWrap, variant);
    syncQuantity(card, variant);
  }

  // ------------------------------------------------------------------
  // Option click / change
  // ------------------------------------------------------------------

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('button[data-option-value]');
      if (!btn) return;

      var optionsWrap = btn.closest('.collection-options');
      var group = btn.closest('[data-option-position]');
      if (!optionsWrap || !group) return;

      event.preventDefault();

      group.querySelectorAll('button[data-option-value]').forEach(function (el) {
        el.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      var variants = getVariants(optionsWrap);
      var selection = getSelection(optionsWrap);
      updateCard(optionsWrap, resolveVariant(optionsWrap, btn));
      markUnavailable(optionsWrap, variants, selection);
    },
    true
  );

  document.addEventListener('change', function (event) {
    var sel = event.target.closest('select.collection-option-select');
    if (!sel) return;
    var optionsWrap = sel.closest('.collection-options');
    if (!optionsWrap) return;

    var variants = getVariants(optionsWrap);
    var selection = getSelection(optionsWrap);
    updateCard(optionsWrap, findVariant(variants, selection));
    markUnavailable(optionsWrap, variants, selection);
  });

  // ------------------------------------------------------------------
  // Init + re-init after AJAX / editor reloads
  // ------------------------------------------------------------------

  function initAll() {
    document.querySelectorAll('.collection-options').forEach(function (wrap) {
      var variants = getVariants(wrap);
      if (!variants.length) return;

      var activeSwatch = wrap.querySelector('.collection-swatch-dot.is-active');
      var selection = getSelection(wrap);
      updateCard(wrap, resolveVariant(wrap, activeSwatch));
      markUnavailable(wrap, variants, selection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('collection:rendered', initAll);

  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.classList && n.classList.contains('collection-options')) ||
            (n.querySelector && n.querySelector('.collection-options'))
          ) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initAll();
            });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ------------------------------------------------------------------
  // Add-to-cart visual feedback
  // ------------------------------------------------------------------

  function showToast(message, type) {
    var t = document.createElement('div');
    t.className = 'collection-toast collection-toast--' + (type || 'info');
    t.setAttribute('role', type === 'error' ? 'alert' : 'status');
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.classList.add('is-visible');
    });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () {
        if (t.parentNode) t.parentNode.removeChild(t);
      }, 300);
    }, 2400);
  }

  function setLoading(btn) {
    btn.dataset.qaState = 'loading';
    btn.classList.remove('is-success', 'is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      btn.dataset.qaQuickAdd = '1';
    } catch (e) {}
  }

  function clearState(btn) {
    btn.classList.remove('is-loading', 'is-success', 'is-error');
    btn.removeAttribute('aria-busy');
    delete btn.dataset.qaState;
    try {
      delete btn.dataset.qaQuickAdd;
    } catch (e) {}
  }

  function setSuccess(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    btn.setAttribute('aria-busy', 'false');
    btn.dataset.qaState = 'success';
    setTimeout(function () {
      clearState(btn);
    }, 1400);
  }

  function setError(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-error');
    btn.setAttribute('aria-busy', 'false');
    btn.dataset.qaState = 'error';
    setTimeout(function () {
      clearState(btn);
    }, 1500);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(ATC_SELECTOR);
      if (!btn) return;

      var hasSoldOut =
        btn.classList.contains('btn--soldout') || btn.classList.contains('is-soldout');
      var hasNoVariant = !btn.dataset.variantId;

      if (hasSoldOut || hasNoVariant) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var strings = getStrings();
        showToast(hasSoldOut ? strings.soldOut : strings.unavailable, 'error');
        return;
      }

      if (btn.dataset.qaState === 'loading') return;
      setLoading(btn);

      setTimeout(function () {
        if (btn.dataset.qaState === 'loading') {
          setError(btn);
          showToast('Could not add to cart. Please try again.', 'error');
        }
      }, 6000);
    },
    true
  );

  document.addEventListener('cart:updated', function () {
    document.querySelectorAll(ATC_SELECTOR + '.is-loading').forEach(function (btn) {
      if (btn.dataset && btn.dataset.qaQuickAdd === '1') setSuccess(btn);
    });
  });

  function patchVanillaCart() {
    var vcs = window.VanillaCartState;
    if (!vcs || typeof vcs.addItem !== 'function' || vcs.__quickAddPatched) return;
    var orig = vcs.addItem.bind(vcs);
    vcs.addItem = function () {
      var args = arguments;
      return orig.apply(null, args).catch(function (err) {
        document.querySelectorAll(ATC_SELECTOR + '.is-loading').forEach(function (btn) {
          if (btn.dataset && btn.dataset.qaQuickAdd === '1') setError(btn);
        });
        showToast(
          (err && err.message) || 'This item could not be added to your cart.',
          'error'
        );
        throw err;
      });
    };
    vcs.__quickAddPatched = true;
  }

  patchVanillaCart();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchVanillaCart);
  }
  setTimeout(patchVanillaCart, 0);
  setTimeout(patchVanillaCart, 500);
})();
